import React, { useEffect, useRef, useState } from 'react';
import Prop from './Prop'

import data from '../Data.json'

const Properties = () => {
  const [isVisible, setIsVisible] = useState(false);
  const missionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (missionRef.current) {
      observer.observe(missionRef.current);
    }

  }, [missionRef]);


  return (
    <div ref={missionRef} className='py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24'>
      <h1 className={`text-2xl sm:text-3xl md:text-4xl font-light tracking-wider p-1 mb-6 sm:mb-10 ${isVisible ?  'animate-slideInLeft opacity-100' : 'opacity-0'}`}>FEATURED PROPERTIES IN DUBAI</h1>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 items-stretch'>
        {data.properties.map((ele, it) => <Prop key={it} ele={ele} it={it}/>)}
      </div>
    </div>
  );
};

export default Properties;
